import { Handler } from 'shared/helpers/typeHelper'

/**
 * Prepares for Azure Maps usage.
 * The map UI uses the azure-maps-control npm package; this just runs the callback
 * so callers can treat the API as "ready". Subscription key is passed when creating the map.
 */
export const loadAzureMapsApis = (
  _azureMapsApiKey: string,
  onLoad?: Handler,
  azureMapsApiLoaded: boolean = false
) => {
  if (/HeadlessChrome/i.test(navigator.userAgent)) return

  if (onLoad && typeof onLoad === 'function' && !azureMapsApiLoaded) {
    onLoad()
  }
}
